import type {
    PriorityPayload,
    PriorityResponse,
} from '@/types/apps/priority.type';
import type {
    ApiResponse,
    PaginatedResult,
    QueryParams,
} from '@/types/common/api.type';
import type { BaseApiClientInterface } from '@/types/service/base-api-client.interface';
import type { Creatable } from '@/types/service/creatable.interface';
import type { Deletable } from '@/types/service/deletable.interface';
import type { Indexable } from '@/types/service/indexable.interface';
import type { Showable } from '@/types/service/showable.interface';
import type { Updatable } from '@/types/service/updatable.interface';

type PriorityListResponse = ApiResponse<PaginatedResult<PriorityResponse>>;

export class PriorityService
    implements Showable, Updatable, Deletable, Creatable, Indexable
{
    public constructor(private apiClient: BaseApiClientInterface) {}

    protected endpoints = {
        base: () => '/api/Priority',
        detail: (id: string) => `/api/Priority/${id}`,
    };

    public index(params?: QueryParams): Promise<PriorityListResponse> {
        return this.apiClient.fetchApi(this.endpoints.base(), params);
    }

    public detail(
        id: string,
        params?: QueryParams
    ): Promise<ApiResponse<PriorityResponse>> {
        return this.apiClient.fetchApi(this.endpoints.detail(id), params);
    }

    public create(
        payload: PriorityPayload
    ): Promise<ApiResponse<PriorityResponse>> {
        return this.apiClient.postApi(this.endpoints.base(), payload);
    }

    public update(
        id: string,
        payload: PriorityPayload
    ): Promise<ApiResponse<PriorityResponse>> {
        return this.apiClient.putApi(this.endpoints.detail(id), payload);
    }

    public destroy(
        ids: string[],
        isHardDeleted: boolean = false
    ): Promise<ApiResponse<void>> {
        return this.apiClient.destroyApi(
            this.endpoints.base(),
            ids,
            isHardDeleted
        );
    }
}
